// extracted by mini-css-extract-plugin
export default {"title":"_8040ff6737","bld":"_3742e13695"};